// extracted by mini-css-extract-plugin
export default {"table":"table_table__hHQML","hiddenable":"table_hiddenable__IkdCY","active-row":"table_active-row__FbvO3"};